import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";
import type { FilterItemType } from "@shared/content-types/types";

import { getEquipmentsPage } from "@/_pages/equipments/api";
import type {
  EquipmentPoints,
  EquipmentsPageType,
} from "@/_pages/equipments/model/types";
import { EquipmentsPage } from "@/_pages/equipments/ui";

type PageProps = {
  cms: {
    filters: FilterItemType[];
    list: EquipmentPoints;
    pageData: EquipmentsPageType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { filters, list, pageData },
  } = props;

  return <EquipmentsPage filters={filters} content={list} hero={pageData} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getEquipmentsPage()),
      };
    },
    { res },
  );
}

export default Page;
